import { IContentTabEnumItem } from 'ui-ng-content-tabs';
import { EnumeratedSetValue, IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

export interface IAppointmentTabEnum extends IEnumeration {
  UPCOMING: IContentTabEnumItem;
  PAST: IContentTabEnumItem;
  ACTIVE: IContentTabEnumItem;
}

export function AppointmentTabEnum($state: ng.ui.IStateService) {
  return Enumeration.useDefinitionAsEnum({
    UPCOMING: {
      tabOrder: 0,
      displayName: 'Upcoming',
      state: 'my.myAppointments.upcoming',
      href: 'my-appointments/upcoming',
      view: '',
      isActive: () => {
        return $state.current.name === 'my.myAppointments.upcoming';
      }
    },
    ACTIVE: {
      tabOrder: 1,
      displayName: 'Active',
      state: 'my.myAppointments.active',
      href: 'my-appointments/active',
      view: '',
      isActive: () => {
        return $state.current.name === 'my.myAppointments.active';
      }
    },
    PAST: {
      tabOrder: 2,
      displayName: 'Past',
      state: 'my.myAppointments.past',
      href: 'my-appointments/past',
      view: '',
      isActive: () => {
        return $state.current.name === 'my.myAppointments.past';
      }
    }
  });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/enums/appointments_tab_enum.ts